export default __webpack_public_path__ + "static/media/lab.e5fdc0c1.jpg";